// Centralized stats configuration for all landing page components
export const LANDING_STATS = {
  projectsCompleted: 50,
  clientSatisfaction: 98,
  yearsExperience: 1,
  happyClients: 40,
  brands: 50,
  satisfactionGuarantee: 100,
  agenciesPartnered: 10
};

export default LANDING_STATS;
